import { FinalCalculation } from '~/Api/User/ProductGroup/RoMaxPrice/FinalCalculation';
import { Product } from '~/Api/User/ProductGroup/RoMaxPrice/Product';
import { Reference } from '~/Api/User/ProductGroup/RoMaxPrice/Reference';

export class RoMaxPrice {
	public finalCalculation: FinalCalculation;

	public links: { [key: string]: string };

	public products: Product[];

	public reference: Reference;

	public constructor(
		reference: Reference,
		products: Product[],
		finalCalculation: FinalCalculation,
		links: { [key: string]: string }
	) {
		this.reference = reference;
		this.products = products;
		this.finalCalculation = finalCalculation;
		this.links = links;
	}

	public getExportXlsLink(): string {
		return this.links['export-xls'];
	}
}
